import React, { useState, useCallback } from "react";
import BootstrapTable from "react-bootstrap-table-next";
import paginationFactory, { PaginationProvider } from "react-bootstrap-table2-paginator";

import { getHandlerTableChange, NoRecordsFoundMessage } from "../../../../../../../_metronic/_helpers";
import { Card, CardBody, CardHeader, Pagination } from "../../../../../../../_metronic/_partials/controls";
import { SIZE_PER_PAGE_LIST } from "../../../../../Common/constants";
import { CircularLoader } from "../../../../../Common/loader";
import { isEqual, isFunction } from "lodash";
import { StockAlertFilter } from "./StockAlertFilter/StockAlertFilter";
import { Tooltip } from "antd";
import { TOOLTIP_BG } from "../../../../../../modules/Common/constants";
import { customTotal } from "../../../../../Common/utils";
import { FormattedMessage } from "react-intl";
export default function ({ stocks, queryParams, setQueryParams, loading, stats }) {
  const defaultSorted = [{ dataField: "id", order: "desc" }];
  // const initialFilter = {
  //   searchKey: "",
  //   sortOrder: "asc", // asc||desc
  //   sortField: "id",
  //   pageNumber: 1,
  //   pageSize: 20,
  // };

  // const [queryParams, setQueryParamsBase] = useState(initialFilter);
  // const setQueryParams = useCallback((nextQueryParams) => {
  //   setQueryParamsBase((prevQueryParams) => {
  //     if (isFunction(nextQueryParams)) {
  //       nextQueryParams = nextQueryParams(prevQueryParams);
  //     }
  //     if (isEqual(prevQueryParams, nextQueryParams)) {
  //       return prevQueryParams;
  //     }
  //     return nextQueryParams;
  //   });
  // }, []);
  // Table columns
  const columns = [
    {
      dataField: "name",
      text: <FormattedMessage id="Product Name" defaultMessage="Product Name" />,
      //   classes: "text-center",
    },
    {
      dataField: "sku",
      text: "SKU/UPC",
      formatter: (sku, cell, cellIndex) => {
        return (
          <>
            {`${cell.sku} /`}
            <br />
            {`${cell.upc}`}
          </>
        );
      },
    },
    {
      dataField: "channel.name",
      text: <FormattedMessage id="Channel Name" defaultMessage="Channel Name" />,
      formatter: (sku, cell, cellIndex) => {
        return <>{`${cell?.channel?.name} `}</>;
      },
    },
    {
      dataField: "in_hand_qty",
      text: "Available QTY",
      classes: "text-danger font-weight-bold",
      //   classes: "text-center",
    },
    {
      dataField: "qty",
      text: <FormattedMessage id="Total Qty" defaultMessage="Total Qty" />,
    },

    {
      dataField: "min_qty",
      text: <FormattedMessage id="Min Qty" defaultMessage="Min Qty" />,
    },
    {
      dataField: "max_qty",
      text: <FormattedMessage id="Max Qty" defaultMessage="Max Qty" />,
    },

    // {
    //   dataField: "min_qty",
    //   text: "Min Qty",
    //   //   classes: "text-center",
    // },
    // {
    //   dataField: "max_qty",
    //   text: "Max Qty",
    //   //   classes: "text-center",
    // },
  ];
  const paginationOptions = {
    custom: true,
    totalSize: stocks?.totalCount,
    sizePerPageList: SIZE_PER_PAGE_LIST,
    sizePerPage: queryParams?.pageSize,
    page: queryParams?.pageNumber,
    paginationTotalRenderer: (from, to, size) => customTotal(from, to, size, <FormattedMessage id="stock alerts" defaultMessage="stock alerts" />),
  };
  const tooltipContent = (
    <FormattedMessage
      id="Stock alert tooltip"
      defaultMessage="The alerts of the products which are low or high in inventory will be shown here. Each stock alert of each channel against a product will be shown here."
    />
  );
  return (
    <>
      <Card style={{ minHeight: "550px" }}>
        <CardHeader
          title={
            <div style={{ display: "flex" }}>
              <h3>
                <FormattedMessage id="Stock Alerts" defaultMessage="Stock Alerts" />
              </h3>
              <div style={{ position: "relative" }}>
                {
                  <div
                    style={{
                      position: "absolute",
                      marginLeft: "8px",
                      bottom: 3,
                      marginBottom: "3px",
                      zindex: 1000,
                      width: 30,
                      height: "88%",
                      alignItems: "center",
                      justifyContent: "center",
                      display: "flex",
                    }}
                  >
                    <Tooltip
                      trigger="click"
                      placement="topLeft"
                      overlayStyle={{ maxWidth: "40%" }}
                      color={TOOLTIP_BG.color}
                      title={<p style={{ color: TOOLTIP_BG.textColor }}>{tooltipContent || "Tooltip content"}</p>}
                    >
                      <img src="/media/svg/icons/Shopping/information2.svg" />
                    </Tooltip>
                  </div>
                }
              </div>
            </div>
          }
        ></CardHeader>
        <CardBody>
          <StockAlertFilter queryParams={queryParams} setQueryParams={setQueryParams} />

          <PaginationProvider pagination={paginationFactory(paginationOptions)}>
            {({ paginationProps, paginationTableProps }) => {
              return (
                <Pagination isLoading={loading} paginationProps={paginationProps}>
                  {loading ? (
                    <CircularLoader />
                  ) : (
                    <BootstrapTable
                      // wrapperClasses="table-responsive"
                      classes="table table-head-custom table-vertical-center"
                      bootstrap4
                      bordered={false}
                      remote
                      keyField="id"
                      data={stocks?.entities ? stocks?.entities : []}
                      columns={columns}
                      defaultSorted={defaultSorted}
                      onTableChange={getHandlerTableChange(setQueryParams)}
                      {...paginationTableProps}
                      noDataIndication={() => (stocks?.entities ? stocks?.entities ? <NoRecordsFoundMessage /> : "" : "")}
                    ></BootstrapTable>
                  )}
                </Pagination>
              );
            }}
          </PaginationProvider>
        </CardBody>
      </Card>
    </>
  );
}
